import * as React from 'react';

import { getTextWithoutParagraph } from 'utils';

import { Items } from './items';
import {
  Wrapper,
  Inner,
  Grid,
  ContentLeft,
  ContentRight,
  StyledTitle,
  Description,
  Illustration,
} from './service-providers-features.styles';

export const FeaturesView = ({ title, description, items, illustration }) => (
  <Wrapper>
    <Inner>
      <Grid>
        <ContentLeft>
          <StyledTitle
            as="h2"
            size="xl"
            dangerouslySetInnerHTML={{
              __html: getTextWithoutParagraph(title),
            }}
          />
          <Description
            dangerouslySetInnerHTML={{
              __html: getTextWithoutParagraph(description),
            }}
          />
          <Items items={items} />
        </ContentLeft>
        <ContentRight>
          <Illustration fixed={illustration} />
        </ContentRight>
      </Grid>
    </Inner>
  </Wrapper>
);
